import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import { DownloadClientsDataInExcel } from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
import { showErrorMessage } from "../Shared/Toast";
function StoragePrice() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);

  const [addressUnitData, setAddressUnitData] = useState<any[]>([]);
  const [storageData, setStorageData] = useState<any[]>([]);
  const [pricePerSQFTPID, setPricePerSQFTPID] = useState<any>(0);
  const [pricePerSQFT, setPricePerSQFT] = useState<any>(0);

  const pricePerSQFTRef: any = useRef(null);
  pricePerSQFTRef.current = pricePerSQFT;

  const [addEditObject, setAddEditObject] = useState({
    storagepricingid: 0,
    Type: "",
    RatePercentageWeekly: "",
    RatePercentageMonthly: "",
    AreaSquareFeet: "",
    ClientPricePerWeekWithoutVAT: "",
    ClientPricePerMonthWithoutVAT: "",
    PricePerWeekWithVAT: "",
    PricePerMonthWithVAT: "",
    PricePerMonthAfter6MonthsWithVAT: "",
    MNVCostPerWeekWithoutVAT: "",
    MNVCostPerMonthWithVAT: "",
    MNVCostPerMonthWithoutVAT: "",
  });

  useEffect(() => {
    MNVAddressUnitGetCompleteGridDataCustom();
    MNVStoragePriceGetCompleteGridDataCustom();
  }, []);

  useEffect(() => {
    GetSelectPricePerSQFTFromPID();
  }, [pricePerSQFTPID]);

  function MNVAddressUnitGetCompleteGridDataCustom() {
    setIsAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVAddressUnit/MNVAddressUnitGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data[1];
          setAddressUnitData(l_response);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVStoragePriceGetCompleteGridDataCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.recordsperpage = 1000;
    object.pricepersqft = pricePerSQFTRef.current;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVStoragePrice/MNVStoragePriceGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setStorageData(l_oResponse[0]);
          if (l_oResponse.length > 1 && l_oResponse[1].length > 0)
            setPricePerSQFT(l_oResponse[1][0]["PricePerSQFT"]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GetSelectPricePerSQFTFromPID() {
    let thispricePerSQFT = 0;
    for (var i = 0; i < addressUnitData.length; i++) {
      if (pricePerSQFTPID == addressUnitData[i].PID) {
        thispricePerSQFT = addressUnitData[i].SelectPricePerSQFT;
        break;
      }
    }
    pricePerSQFTRef.current = thispricePerSQFT;
    setPricePerSQFT(thispricePerSQFT);
    MNVStoragePriceGetCompleteGridDataCustom();
  }

  function checkValidation() {
    let IsOkay = true;
    let Message = "";
    if (addEditObject.Type == "") {
      IsOkay = false;
      Message = "Type required";
    } else if (addEditObject.RatePercentageWeekly == "") {
      IsOkay = false;
      Message = "Rate Weekly  required";
    } else if (addEditObject.RatePercentageMonthly == "") {
      IsOkay = false;
      Message = "Rate Monthly required";
    } else if (addEditObject.AreaSquareFeet == "") {
      IsOkay = false;
      Message = "Area Square Feet required";
    }

    if (IsOkay) {
      MNVStoragePriceSaveCustom();
    } else {
      showErrorMessage(Message);
    }
  }

  function MNVStoragePriceSaveCustom() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvstoragepriceid = addEditObject.storagepricingid;
    object.type = addEditObject.Type;
    object.ratepercentageweekly = addEditObject.RatePercentageWeekly;
    object.ratepercentagemonthly = addEditObject.RatePercentageMonthly;
    object.areasquarefeet = addEditObject.AreaSquareFeet;
    object.clientpriceweekly = addEditObject.ClientPricePerWeekWithoutVAT;
    object.clientpricemonthly = addEditObject.ClientPricePerMonthWithoutVAT;
    object.priceweekincvat = addEditObject.PricePerWeekWithVAT;
    object.pricemonthincvat = addEditObject.PricePerMonthWithVAT;
    object.priceafter6months = addEditObject.PricePerMonthAfter6MonthsWithVAT;
    object.costperweekexvat = addEditObject.MNVCostPerWeekWithoutVAT;
    object.costpermonthexvat = addEditObject.MNVCostPerMonthWithVAT;
    object.ourcostincvat = addEditObject.MNVCostPerMonthWithoutVAT;

    // console.log("Payload being sent to backend:", object);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVStoragePrice/MNVStoragePriceSaveCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          setIsAddNew(0);
          MNVStoragePriceGetCompleteGridDataCustom();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVStoragePriceDeleteRecordCustom(mnvstoragepriceid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvstoragepriceid = mnvstoragepriceid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVStoragePrice/MNVStoragePriceDeleteRecordCustom",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          // console.log(l_response);
          MNVStoragePriceGetCompleteGridDataCustom();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        MNVStoragePriceDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-end mb-10">
              <div className="flex-daj flex-gap10">
                <div className="field-input">
                  <select
                    className="input-field"
                    value={pricePerSQFTPID}
                    onChange={(e) => setPricePerSQFTPID(e.target.value)}
                  >
                    <option value={0}>Please Select</option>
                    {addressUnitData &&
                      addressUnitData.map((Item: any, index: any) => (
                        <React.Fragment key={index}>
                          <option value={Item.PID}>{Item.Title}</option>
                        </React.Fragment>
                      ))}
                  </select>
                </div>
                <div className="flex-daj btn-start flex-gap10">
                  <div>
                    {storageData.length > 0 && (
                      <div className="price-highlight flex-da flex-gap10">
                        <span className="font-12">Price Per SQFT (£): </span>
                        <input
                          className="input-field"
                          type="number"
                          value={pricePerSQFT}
                          onChange={(e) => {
                            setPricePerSQFT(e.target.value);
                            pricePerSQFTRef.current = e.target.value;
                          }}
                          onBlur={(e) =>
                            MNVStoragePriceGetCompleteGridDataCustom()
                          }
                          style={{
                            width: "100px",
                            padding: "4px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => {
                      setAddEditObject({
                        storagepricingid: 0,
                        Type: "",
                        RatePercentageWeekly: "",
                        RatePercentageMonthly: "",
                        AreaSquareFeet: "",
                        ClientPricePerWeekWithoutVAT: "",
                        ClientPricePerMonthWithoutVAT: "",
                        PricePerWeekWithVAT: "",
                        PricePerMonthWithVAT: "",
                        PricePerMonthAfter6MonthsWithVAT: "",
                        MNVCostPerWeekWithoutVAT: "",
                        MNVCostPerMonthWithVAT: "",
                        MNVCostPerMonthWithoutVAT: "",
                      });
                      setIsAddNew(1);
                    }}
                  >
                    Add New
                  </a>
                </div>
                <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblstorageprice",
                      "Storage Price"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flow-auto-sm">
              <table className="reuse-table fixed-table" id="tblstorageprice">
                <thead>
                  <tr>
                    <th className="th-white"></th>
                    <th className="empty-space"></th>
                    <th className="th-white"></th>
                    <th colSpan={2}>Price per WEEK</th>
                    <th colSpan={2}>Price per MONTH</th>
                    <th>Price per WEEK after 6 months</th>
                    <th>Price per MONTH after 6 months</th>
                    <th className="empty-space"></th>
                    <th>What it cost us per week</th>
                    <th>What it cost us per month</th>
                    <th>Our cost per month</th>
                    <th className="th-white"></th>
                  </tr>

                  <tr>
                    {/* <th>Type</th> */}
                    {/* <th>Rate % Weekly</th> */}
                    <th>Rate % Monthly</th>
                    <th className="empty-space"></th>
                    <th>Area Square feet</th>
                    <th className="font-400">No VAT</th>
                    <th className="font-400">Inc. VAT</th>
                    <th className="font-400">No VAT</th>
                    <th className="font-400">Inc. VAT</th>
                    <th className="font-400">Inc. VAT</th>
                    <th className="font-400">Inc. VAT</th>
                    <th className="empty-space"></th>
                    <th>Excluding VAT</th>

                    <th>Excluding VAT</th>
                    <th>Inc. VAT</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {storageData &&
                    storageData.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          {/* <td>{item.Type}</td> */}
                          {/* <td className="text-right">
                            {item.RatePercentageWeekly?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                            %
                          </td> */}
                          <td className="text-right">
                            {item.RatePercentageMonthly?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                            %
                          </td>
                          <td className="empty-space"></td>
                          <td className="text-right left-border">
                            {item.AreaSquareFeet}
                          </td>
                          <td className="text-right vc-1">
                            £
                            {item.ClientPricePerWeekWithoutVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td className="text-right vc-2">
                            <b>
                              £
                              {item.PricePerWeekWithVAT?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </b>
                          </td>
                          <td className="text-right vc-1">
                            £
                            {item.ClientPricePerMonthWithoutVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td className="text-right vc-2">
                            <b>
                              £
                              {item.PricePerMonthWithVAT?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </b>
                          </td>
                          <td className="text-right vc-3">
                            £
                            {item.PricePerWeekAfter6MonthsWithVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td className="text-right vc-3">
                            £
                            {item.PricePerMonthAfter6MonthsWithVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td className="empty-space"></td>
                          <td className="text-right">
                            £
                            {item.MNVCostPerWeekWithoutVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>

                          <td className="text-right">
                            £
                            {item.MNVCostPerMonthWithoutVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>

                          <td className="text-right">
                            £
                            {item.MNVCostPerMonthWithVAT?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setAddEditObject({
                                    storagepricingid: item.MNVStoragePriceID,
                                    Type: item.Type,
                                    RatePercentageWeekly:
                                      item.RatePercentageWeekly,
                                    RatePercentageMonthly:
                                      item.RatePercentageMonthly,
                                    AreaSquareFeet: item.AreaSquareFeet,
                                    ClientPricePerWeekWithoutVAT:
                                      item.ClientPricePerWeekWithoutVAT,
                                    ClientPricePerMonthWithoutVAT:
                                      item.ClientPricePerMonthWithoutVAT,
                                    PricePerWeekWithVAT:
                                      item.PricePerWeekWithVAT,
                                    PricePerMonthWithVAT:
                                      item.PricePerMonthWithVAT,
                                    PricePerMonthAfter6MonthsWithVAT:
                                      item.PricePerMonthAfter6MonthsWithVAT,
                                    MNVCostPerWeekWithoutVAT:
                                      item.MNVCostPerWeekWithoutVAT,
                                    MNVCostPerMonthWithoutVAT:
                                      item.MNVCostPerMonthWithoutVAT,
                                    MNVCostPerMonthWithVAT:
                                      item.MNVCostPerMonthWithVAT,
                                  });
                                  setIsAddNew(2);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18"
                                  height="18"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are you sure to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVStoragePriceID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18"
                                  height="18"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </>
      )}

      {(isAddNew === 1 || isAddNew === 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-1111 gap-20">
              {/* Type Input */}
              {/* <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color"> Type:</span>
                <input
                  className="input-field w-100"
                  placeholder="Type"
                  type="text"
                  value={addEditObject.Type}
                  onChange={(e) =>
                    setAddEditObject((prev: any) => ({
                      ...prev,
                      Type: e.target.value,
                    }))
                  }
                />
              </div> */}

              {/* RateWeekly Input */}
              {/* <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  {" "}
                  Rate % Weekly:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Rate % Weekly"
                  type="text"
                  value={addEditObject.RatePercentageWeekly}
                  onChange={(e) =>
                    setAddEditObject((prev: any) => ({
                      ...prev,
                      RatePercentageWeekly: e.target.value,
                    }))
                  }
                />
              </div> */}

              {/* RateMonthly Input */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  {" "}
                  Rate % Monthly:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Rate % Monthly"
                  type="text"
                  value={addEditObject.RatePercentageMonthly}
                  onChange={(e) =>
                    setAddEditObject((prev: any) => ({
                      ...prev,
                      RatePercentageMonthly: e.target.value,
                    }))
                  }
                />
              </div>

              {/* AreaSqFt Input */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Area Square Feet:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Area Square Feet"
                  type="text"
                  value={addEditObject.AreaSquareFeet}
                  onChange={(e) =>
                    setAddEditObject((prev: any) => ({
                      ...prev,
                      AreaSquareFeet: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default StoragePrice;
